import styled from 'styled-components';

export const Container = styled.div`
  margin: 2rem auto 0 auto;
`;

export const Toggler = styled.a`
  cursor: pointer;
  border-bottom: 1px solid #000;

  &:hover {
    opacity: .8;
  }
`;

export const Box = styled.div`
  margin-top: 2rem;
  padding: 1rem;
  border: 2px solid #8FB7B5;
  text-align: left;
`;